import { getGetApiNotificationSettingsGetQueryKey, LineNotificationSettingsData, useGetApiNotificationSettingsGet } from "@/API";
import { CopyText } from "@/Components/CopyText";
import { Anchor, Group, Modal, NavLink, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { PropsWithChildren } from "react";

export function LineNotificationRegisterButton(props: { workspaceId: string, id: string } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const settings = useGetApiNotificationSettingsGet({ workspaceId: props.workspaceId, id: props.id }, {
        query: {
            queryKey: getGetApiNotificationSettingsGetQueryKey({ workspaceId: props.workspaceId, id: props.id }),
            enabled: opened
        }
    })
    var data = settings.data?.data.notificationData as (LineNotificationSettingsData | undefined)
    const webhookUrl = `${window.origin}/api/notification/line/register/${props.id}`
    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="Line註冊發送對象">
            <Text mb="md">
                如果無法取得發送對象ID，請依照以下方式註冊
            </Text>
            <Group gap={0}>
                <Text>1.清空</Text>
                <Text fw={600}>發送對象
                </Text>
                <Text fw={600} c={data?.to ? "red" : "green"}>
                    {
                        data?.to ? "(尚未清空)" : "(已清空)"
                    }
                </Text>
            </Group>
            <Anchor href="https://developers.line.biz/console/" target="_blank">
                LINE Console
            </Anchor>
            <Group gap={0}>
                <Text>
                    2.設定Token(Channel access token (long-lived))
                </Text>
                <Text fw={600} c={data?.token ? "green" : "red"}>
                    {
                        data?.token ? "(尚未設定)" : "(已設定)"
                    }
                </Text>
            </Group>
            <Text>
                3.註冊以下Webhook
            </Text>
            <CopyText text={webhookUrl} />
            <Text>
                4.於聊天室發送以下訊息
            </Text>
            <CopyText text={`/register ${settings.data?.data.name}`.trim()} />
            <Text>
                5.如果出現註冊成功等字樣，表示註冊完成
            </Text>
        </Modal >
    </>
}